import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bfc38838")

_pushScopeId("data-v-bfc38838")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("span", { style: {"margin-left":"10px"} }, "GameRobot")
], -1)
const _hoisted_2 = { style: {"padding":"20px"} }
const _hoisted_3 = {
  key: 0,
  style: {"margin-bottom":"15px"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("登录")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, { style: {"height":"calc(100% - 62px)"} }, {
    default: _withId(() => [
      _createVNode(_component_el_main, {
        style: {"height":"100%"},
        class: "Login"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, {
            type: "flex",
            justify: "center",
            align: "middle",
            style: {"height":"100%"}
          }, {
            default: _withId(() => [
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 10,
                md: 9,
                lg: 8,
                xl: 7
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_card, {
                    shadow: "always",
                    class: "box-card"
                  }, {
                    header: _withId(() => [
                      _hoisted_1
                    ]),
                    default: _withId(() => [
                      _createVNode("div", _hoisted_2, [
                        _createVNode(_component_el_form, {
                          "label-position": _ctx.labelPosition,
                          model: _ctx.formLabelAlign
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formLabelAlign.username,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formLabelAlign.username = $event)),
                                  placeholder: "请输入账号",
                                  "prefix-icon": "el-icon-user-solid"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formLabelAlign.password,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formLabelAlign.password = $event)),
                                  placeholder: "请输入密码",
                                  "prefix-icon": "el-icon-lock"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (_ctx.loginError)
                              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                                  _createVNode(_component_el_alert, {
                                    title: "Incorrect username or password",
                                    type: "error"
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.submitForm,
                                  style: {"float":"right"}
                                }, {
                                  default: _withId(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["label-position", "model"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})